<template>
  <div class="page-container">
    <!-- Breadcrumb / Header -->
    <div class="head-title">
      <div class="left">
        <ul class="breadcrumb">
          <li>
            <a href="#" class="active">{{ $t("management") }} {{ $t("projects") }}</a>
          </li>
        </ul>
      </div>
    </div>

    <!-- Main Workspace Card Wrapper -->
    <div class="main-card">
      <!-- Navigation Links Grid -->
      <div class="body-grid">
        
        <!-- Projects Core -->
        <div class="part" v-if="hasPermission('projects')">
          <h6>{{ $t("projects") }}</h6>
          <ul>
            <li>
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/ProjectsManagement/allprojects">
                {{ $t("projects") }}
              </router-link>
            </li>
            <li>
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/ProjectsManagement/createproject">
                {{ $t("add") }} {{ $t("project") }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Products & Classifications -->
        <div class="part" v-if="hasPermission('project_all_products') || hasPermission('project_product_categories') || hasPermission('project_all_tasks') || hasPermission('project_product_transfer')">
          <h6>{{ $t("products") }} / {{ $t("items") }} / {{ $t("classification") }}</h6>
          <ul>
            <li v-if="hasPermission('project_all_products')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/purchases/AllProducts">
                {{ $t("products") }}
              </router-link>
            </li>
            <li v-if="hasPermission('project_product_categories')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/purchases/AllProducts/ProductCategories">
                {{ $t("items") }}
              </router-link>
            </li>
            <li v-if="hasPermission('project_all_tasks')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/AdminDashboard/AllTasks">
                {{ $t("classification") }}
              </router-link>
            </li>
            <li v-if="hasPermission('project_product_transfer')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/ProjectsManagement/AllProductTransfer">
                نقل المنتجات للمشروعات
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Purchases -->
        <div class="part" v-if="hasPermission('project_purchases_list') || hasPermission('project_add_purchase_bill') || hasPermission('project_return_purchase_bill')">
          <h6>{{ $t("purchases") }}</h6>
          <ul>
            <li v-if="hasPermission('project_purchases_list')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/ProjectsManagement/allprojectsbills">
                {{ $t("purchases") }}
              </router-link>
            </li>
            <li v-if="hasPermission('project_add_purchase_bill')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/ProjectsManagement/CreateProjectsBill">
                {{ $t("add") }} {{ $t("invoice") }} {{ $t("purchases") }}
              </router-link>
            </li>
            <li v-if="hasPermission('project_return_purchase_bill')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/ProjectsManagement/AllReturnsBills">
                {{ $t("returns") }} {{ $t("purchases") }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Suppliers -->
        <div class="part" v-if="hasPermission('project_list_suppliers') || hasPermission('project_add_supplier') || hasPermission('project_supplier_statement') || hasPermission('project_supplier_bonds')">
          <h6>{{ $t("suppliers") }}</h6>
          <ul>
            <li v-if="hasPermission('project_list_suppliers')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/purchases/suppliers">
                {{ $t("suppliers") }}
              </router-link>
            </li>
            <li v-if="hasPermission('project_add_supplier')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/AdminDashboard/Suppliers/NewSupplier">
                {{ $t("add") }} {{ $t("supplier") }}
              </router-link>
            </li>
            <li v-if="hasPermission('project_supplier_statement')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/ProjectsManagement/SuplierStatementprojects">
                {{ $t("Account Statement") }} {{ $t("suppliers") }}
              </router-link>
            </li>
            <li v-if="hasPermission('project_supplier_bonds')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/ProjectsManagement/AllSupplierReceiptsproject">
                {{ $t("receipts") }} {{ $t("suppliers") }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Contractors -->
        <div class="part" v-if="hasPermission('project_contractors') || hasPermission('project_contractors_contracts') || hasPermission('project_account_statement_extracts') || hasPermission('project_extract_payment_vouchers') || hasPermission('project_contractors_account_statements')">
          <h6>{{ $t("contractors") }}</h6>
          <ul>
            <li v-if="hasPermission('project_contractors')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/ProjectsManagement/contractors">
                {{ $t("contractors") }}
              </router-link>
            </li>
            <li v-if="hasPermission('project_contractors_contracts')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/ProjectsManagement/contractors/allcontractorscontracts">
                {{ $t("contracts") }} {{ $t("contractors") }}
              </router-link>
            </li>
            <li v-if="hasPermission('project_account_statement_extracts')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/ProjectsManagement/AllExtracts">
                {{ $t("extracts") }}
              </router-link>
            </li>
            <li v-if="hasPermission('project_extract_payment_vouchers')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/ProjectsManagement/AllExtractsPayment">
                {{ $t("receipts") }} {{ $t("paid") }} {{ $t("extracts") }}
              </router-link>
            </li>
            <li v-if="hasPermission('project_contractors_account_statements')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/ProjectsManagement/ContractorStatementprojects">
                {{ $t("Account Statement") }} {{ $t("contractors") }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Petty Cash Accounts -->
        <div class="part" v-if="hasPermission('projects_covenant_account_statement') || hasPermission('project_receive_covenant')">
          <h6>{{ $t("petty") }} {{ $t("projects") }}</h6>
          <ul>
            <li v-if="hasPermission('project_receive_covenant')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/ProjectsManagement/AllReceivePatty">
                {{ $t("receive") }} {{ $t("petty") }}
              </router-link>
            </li>
            <li v-if="hasPermission('projects_covenant_account_statement')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/ProjectsManagement/AllReceivePatty/pattystatement">
                {{ $t("Account Statement") }} {{ $t("petty") }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Project Statements & Reports -->
        <div class="part" v-if="hasPermission('project_reports') || hasPermission('cost_report') || hasPermission('project_cost_summary') || hasPermission('project_cost_by_category') || hasPermission('project_cost_details') || hasPermission('project_vat_owner') || hasPermission('project_vat_owner_all')">
          <h6>{{ $t("reports") }} {{ $t("projects") }}</h6>
          <ul>
            <li v-if="hasPermission('project_cost_summary')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/ProjectsManagement/CostReport">
                {{ $t("cost") }}
              </router-link>
            </li>
            <li v-if="hasPermission('project_cost_by_category')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/ProjectsManagement/CostReportDetailsClass">
                التكلفة بالتبويب
              </router-link>
            </li>
            <li v-if="hasPermission('project_cost_details')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/ProjectsManagement/CostReportitems">
                {{ $t("details") }} {{ $t("cost") }}
              </router-link>
            </li>
            <li v-if="hasPermission('project_vat_owner')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/ProjectsManagement/taxreportowners">
                {{ $t("tax") }} {{ $t("purchases") }} {{ $t("owners") }}
              </router-link>
            </li>
            <li v-if="hasPermission('project_vat_owner_all')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/ProjectsManagement/allOver-report-owners">
                ضريبة المشتريات ملاك شامل
              </router-link>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: ["css"],
  data() {
    return {};
  },
  methods: {
    ...mapActions(["redirectTo"]),
    hasPermission(permission) {
      return this.$store?.getters?.hasPermission ? this.$store.getters.hasPermission(permission) : true;
    }
  },
};
</script>

<style lang="scss" scoped>
/* Reset and Container Basics */
.page-container {
  direction: v-bind("css.EN");
  padding: 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f8f9fa;
  min-height: 100vh;
}

.breadcrumb {
  list-style: none;
  padding: 0;
  margin-bottom: 20px;
  
  li a {
    text-decoration: none;
    font-weight: 600;
    font-size: 1.2rem;
    color: #333;
    
    &.active {
      color: v-bind("css.color");
    }
  }
}

/* Main Dashboard Card Wrapper */
.main-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  padding: 24px;
}

/* Bottom Navigation Grid System */
.body-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 24px;
}

.part {
  background-color: #ffffff;
  border: 1px solid #edf2f7;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
  align-self: start;

  h6 {
    font-size: 16px;
    font-weight: 700;
    color: #1a202c;
    margin-top: 0;
    margin-bottom: 16px;
    border-bottom: 2px solid #edf2f7;
    padding-bottom: 8px;
    text-transform: uppercase;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      font-size: 15px;

      &:last-child {
        margin-bottom: 0;
      }

      .bi-three-dots-vertical {
        color: #a0aec0;
        margin-right: 8px;
        font-size: 14px;
      }

      a {
        color: #4a5568;
        text-decoration: none;
        transition: color 0.2s;

        &:hover {
          color: v-bind("css.color");
          font-weight: 500;
        }
      }
    }
  }
}

/* Responsive Breakpoints */
@media screen and (max-width: 992px) {
  .body-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width: 576px) {
  .page-container {
    padding: 10px;
  }
  
  .main-card {
    padding: 16px;
  }

  .body-grid {
    grid-template-columns: 1fr;
    grid-gap: 16px;
  }
  
  .part {
    padding: 16px;
    
    h6 {
      font-size: 14px;
      margin-bottom: 12px;
    }
    
    ul li {
      font-size: 14px;
      margin-bottom: 10px;
    }
  }
}
</style>